export interface PickUpDeliveryInfo {
  name: string;
  address: string;
}
